// extracted by mini-css-extract-plugin
export default {"expert":"G5Et89OT","withoutJobTitle":"VfILhGdk","authorInfo":"rcgST_am","avatar":"FNinMy_z"};